export default __webpack_public_path__ + "static/media/forgot-password-dark.5349f5b0.svg";